export class AnimalModel {
  id: string;
  type: string;

  constructor({ id, type }: { id: string; type: string }) {
    this.id = id;
    this.type = type;
  }
}
